import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import CaseList from '../../../../Components/CaseList';
import { useCanViewCases } from '../../../../Hooks/featurePermission';
import { useFeaturePermissionsLoaded } from '../../../../Selectors/Permission';

export const Route = createFileRoute('/(main)/_layout/cases/_cases')({
  component: RouteComponent,
});

function RouteComponent() {
  const featurePermissionsLoaded = useFeaturePermissionsLoaded();
  const canViewCases = useCanViewCases();

  // Wait for permissions to load before deciding whether to redirect.
  if (!featurePermissionsLoaded) {
    return null;
  }

  if (!canViewCases) {
    return <Navigate to="/chats" />;
  }

  return (
    <div className="cases-list">
      <CaseList />
      <Outlet />
    </div>
  );
}
